/**
 * THE PICKER PROMPTS FOR THIS MODULE'S OWN NOUNS — one wording, imported rather than retyped.
 *
 * `packages/ui-kit`'s `PROMPT` is the platform's vocabulary, and its own comment records why it
 * exists: before it there were *"six spellings of the same prompt across nineteen screens"*. It
 * carries `project` and `opportunity`. **Initiative and version are the same CLASS of field**
 * (D-014) but they are this module's nouns, so the wording lives here rather than being pushed
 * into the shared package — and it lives in ONE place so the next ERP screen that needs it
 * cannot spell it differently.
 *
 * The form is `PROMPT`'s, exactly: an em dash, "Select a/an", the noun, an em dash.
 */
export const ERP_PROMPT = {
  initiative: '— Select an Initiative —',
  version: '— Select a Version —',
  /**
   * Not a prompt but an EMPTY STATE, and the two are different statements: the initiative is
   * chosen and simply has no model yet, so there is nothing to select rather than something
   * waiting to be selected. The wording is the one the native `<option>` carried before D-014.
   */
  noVersionsYet: '— none yet —',
  /**
   * ── THESE TWO ARE REAL CHOICES, NOT PROMPTS ───────────────────────────────────────────
   *
   * `PROMPT` keeps `allProjects` / `allOpportunities` beside its prompts for the same reason and
   * states the rule: they are *"NOT prompts — they are real choices, and they stay distinct
   * precisely so nobody replaces a working 'show me everything' filter with a 'you have not
   * chosen yet' placeholder. The two mean opposite things."*
   *
   * Both are the wording the native `<option value="">` carried before D-014, unchanged. Each
   * one's field therefore passes `allowClear={false}`: the row already exists, so `SelectField`
   * must not add a second blank one — which would both duplicate it and write `UNSET` into a
   * field the server reads.
   */
  noParentFunctionalArea: '— None: this is a functional area —',
  startEmpty: '— Start empty —',
} as const;
